import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { inject } from 'vue';
import type { AnchorStroe } from './anchor.vue';
/*
 * @author: Lew
 * @e-mail: yl617341586@163.com
 * @date: 2022/07/04 23:30:56
 * @description: 锚点链接
 */
export interface AnchorLinkoption {
  title: string;
  href: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'anchor-link',
  props: {
    title: {},
    href: {}
  },
  setup(__props: any) {


const anchor = inject<AnchorStroe>('anchor', { currentHref: '' });
anchor.currentHref = location.hash;
const handleClick = (href: string) => {
  anchor.currentHref = href;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(['anchor-link', _unref(anchor).currentHref === __props.href && 'anchor-link--active']),
    onClick: _cache[0] || (_cache[0] = () => handleClick(__props.href))
  }, [
    _createElementVNode("a", {
      class: "anchor-link-title",
      href: __props.href
    }, _toDisplayString(__props.title), 9, _hoisted_1),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})